module.exports = __webpack_public_path__ + "static/resume-2cb2e5b6ca71d9fab84c0ec2bb2612e1.pdf";